module.exports = __webpack_public_path__ + "img/up-long.01fff858.svg";